import type { Brand, Model } from '@studio/models/device';
import { uniq } from 'lodash-es';

/**
 * Get the device's nickname given its brand and model.
 *
 * @param brand - Device brand.
 * @param model - Device model.
 * @returns Device nickname.
 * @see https://bit.ly/3zyC8es
 */
export const getNickname = (
  brand: Pick<Brand, 'id' | 'name'>,
  model: Pick<Model, 'id' | 'name'>
): string => uniq([brand.name, model.name]).join(' ');
